import React, { useEffect, useState } from 'react'

export type TimelinesFocusContextType = {
  focusLock: number | undefined
  setFocusLock?: React.Dispatch<React.SetStateAction<number | undefined>>
}

export const TimelinesFocusContext =
  React.createContext<TimelinesFocusContextType>({
    focusLock: undefined,
  })

export type TimelinesFocusManagerProps = {
  scrollBoxRef: React.RefObject<HTMLDivElement>
}

export const TimelinesFocusManager = ({
  scrollBoxRef,
  children,
}: React.PropsWithChildren<TimelinesFocusManagerProps>) => {
  const [focusLock, setFocusLock] = useState<number | undefined>()

  // Disable scrolling while focus is locked - this is an experiment to emulate how
  // Slack or Discord handles this UX
  useEffect(() => {
    const scrollBox = scrollBoxRef.current
    if (!scrollBox) {
      return
    }

    if (focusLock) {
      scrollBox.style.pointerEvents = 'none'
    } else {
      scrollBox.style.pointerEvents = 'all'
    }
  }, [focusLock, scrollBoxRef])

  // Ensure that when this component unmounts that the scrollbox is able to be accessed
  useEffect(() => {
    const scrollBox = scrollBoxRef.current
    if (!scrollBox) {
      return
    }

    return () => {
      scrollBox.style.pointerEvents = 'all'
    }
  }, [scrollBoxRef])

  return (
    <TimelinesFocusContext.Provider
      value={{
        focusLock,
        setFocusLock,
      }}
    >
      {children}
    </TimelinesFocusContext.Provider>
  )
}
